import { useMutation } from "@tanstack/react-query";
import { instance } from "api/apiBase";
import { Layout } from "providers/Layout";
import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, ButtonVariant } from "shared/components";
import { BreadCrumbs } from "shared/components/BreadCrumbs";
import { Switch } from "shared/components/forms/Switch";
import { getErrorMessage } from "utils/error";
import { useAuthContext } from "providers/Auth";

export const NotificationsView = () => {
  const { auth } = useAuthContext();
  const notificationSettings = auth?.notification_settings
    ? auth.notification_settings
    : {};
  const [notify, setNotify] = useState(
    notificationSettings["application_submitted"] || false
  );
  const { mutate: updateNotifications } = useMutation({
    mutationKey: ["UPDATE_NOTIFICATIONS"],
    mutationFn: () => {
      notificationSettings["application_submitted"] = notify;
      return instance.patch(`/portal/v1/users/notification_settings`, {
        notification_settings: notificationSettings
      });
    },
    onSuccess: () => {
      toast.success("Notifications were successfully updated");
    },
    onError: (error) => {
      toast.error(getErrorMessage(error));
    }
  });

  return (
    <Layout
      header={
        <>
          <div className="flex items-center justify-between border-b border-alpha-40 px-3 md:px-6 pb-3">
            <BreadCrumbs
              crumbs={[
                {
                  title: "Settings",
                  href: "/settings"
                },
                {
                  title: "Notifications",
                  href: "/settings/notifications"
                }
              ]}
            />
          </div>
          <div className="p-6">
            <h1 className="text-xl font-bold text-content-1000">
              Notifications
            </h1>
          </div>
        </>
      }
      footer={
        <div className="flex justify-end gap-2">
          <Link to="/settings">
            <Button className="w-[125px]">Cancel</Button>
          </Link>
          <Button
            className="w-[125px]"
            variant={ButtonVariant.PRIMARY}
            onClick={() => updateNotifications()}
          >
            Save
          </Button>
        </div>
      }
    >
      <div className="flex flex-wrap">
        <div className="bg-background-1000 rounded-lg border border-alpha-100 shadow-xs p-6 lg:min-w-[788px]">
          <p className="text-sm text-content-400 font-medium">Applications</p>
          <div className="border-b border-alpha-40 my-2" />
          <Switch
            label="Notify me via email when applications are ready for a decision"
            wrapperClassName="pt-8"
            className="text-base font-medium text-content-1000"
            checked={notify}
            onChange={setNotify}
          />
        </div>
      </div>
    </Layout>
  );
};
